import { PublicShell } from "../../components/Layouts";
import { useEffect, useState } from "react";
import { Mail, MessageCircle } from "lucide-react";
import { api } from "../../lib/api";

export default function Contact() {
  const [s, setS] = useState({});
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sent, setSent] = useState(false);
  useEffect(() => { api.get("/settings/public").then((r) => setS(r.data || {})).catch(() => {}); }, []);
  return (
    <PublicShell>
      <main className="page">
        <div className="page-intro">
          <div className="eyebrow">GET IN TOUCH</div>
          <h1>Talk to the<br /><em>team.</em></h1>
          <p>Questions about packages, deposits, referrals or withdrawals? Reach out — we respond thoughtfully.</p>
        </div>
        <div className="contact-grid">
          <div className="contact-card" data-testid="contact-email">
            <div className="contact-icon"><Mail /></div>
            <strong>Email</strong>
            <p>{s.support_email || "support@helpingagent.io"}</p>
          </div>
          <div className="contact-card" data-testid="contact-telegram">
            <div className="contact-icon"><MessageCircle /></div>
            <strong>Telegram</strong>
            <p>{s.telegram_url || "Coming soon"}</p>
          </div>
          <form
            className="contact-form"
            onSubmit={(e) => { e.preventDefault(); setSent(true); }}
          >
            <div className="eyebrow">SEND A NOTE</div>
            <label>Your name<input data-testid="contact-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></label>
            <label>Email<input data-testid="contact-email-input" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required /></label>
            <label>Message<textarea data-testid="contact-message" rows="4" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} required /></label>
            {sent ? <p className="success">Thank you — we will reply by email.</p> : <button data-testid="contact-submit" className="btn btn-accent full" type="submit">Send message</button>}
          </form>
        </div>
      </main>
    </PublicShell>
  );
}
